var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50001 2.5C8.69032 2.5 8.86413 2.60804 8.94837 2.77869L10.3771 5.67323L13.5723 6.14026C13.7606 6.16778 13.9169 6.29978 13.9756 6.48078C14.0343 6.66179 13.9852 6.86041 13.8489 6.99318L11.5373 9.24468L12.0828 12.4255C12.115 12.6131 12.0379 12.8027 11.8839 12.9145C11.7299 13.0264 11.5257 13.0411 11.3573 12.9525L8.50001 11.4499L5.64274 12.9525C5.47428 13.0411 5.27014 13.0264 5.11615 12.9145C4.96216 12.8027 4.88504 12.6131 4.91721 12.4255L5.46275 9.24468L3.15115 6.99318C3.01484 6.86041 2.9657 6.66179 3.02439 6.48078C3.08308 6.29978 3.23942 6.16778 3.4277 6.14026L6.62288 5.67323L8.05166 2.77869C8.1359 2.60804 8.30971 2.5 8.50001 2.5Z",
    fill: "#747D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.3f29528b4af370275b4097270e2f108d.svg";
export { ForwardRef as ReactComponent };